import { brandNameOrDefault, formatBRL, formatDateTimeBR, receiptLogoHtml } from './print-receipt.util';

export interface ComprovanteTransferencia {
  nrAdiantamento: number;
  valor: number;
  origemNome: string;
  origemCpf: string;
  destinoNome: string;
  destinoCpf: string;
  dataHora: string;
  usuario: string;
  logo: string;
  cdEmpresa: string;
  marca: string;
}

// Origem e destino lado a lado, e o texto diz que o pagamento nao mudou de dono: quem le o
// papel precisa entender que so o direito de gastar mudou.
export function montarComprovanteTransferencia(dados: ComprovanteTransferencia): string {
  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(dados.logo, dados.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Comprovante de Transferência</p>
        <p class="subtitle">Transferência de saldo de adiantamento</p>
        <p class="receipt-number">Adiantamento Nº ${dados.nrAdiantamento}</p>
      </div>
    </div>
    <table class="data">
      <tr><td class="label">Titular (quem pagou)</td><td class="value">${dados.origemNome || '—'}</td></tr>
      <tr><td class="label">CPF do titular</td><td class="value">${dados.origemCpf || '—'}</td></tr>
      <tr><td class="label">Saldo liberado para</td><td class="value">${dados.destinoNome || '—'}</td></tr>
      <tr><td class="label">CPF do destinatário</td><td class="value">${dados.destinoCpf || '—'}</td></tr>
      <tr><td class="label">Data/Hora da transferência</td><td class="value">${formatDateTimeBR(dados.dataHora)}</td></tr>
      <tr><td class="label">Transferido por</td><td class="value">${dados.usuario}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Saldo transferido</div>
      <div class="amount">${formatBRL(dados.valor)}</div>
    </div>
    <p style="font-size: 10px; color: #626272; margin-top: 8px;">
      O pagamento continua registrado em nome do titular. A transferência muda apenas quem pode
      utilizar o saldo.
    </p>
    <div class="footer">${brandNameOrDefault(dados.marca)} — TRANSFERÊNCIA — Comprovante sem valor fiscal</div>
  `;
}

export interface TermoTransferenciaImpresso {
  nrAdiantamento: number;
  valor: number;
  origemNome: string;
  origemCpf: string;
  destinoNome: string;
  destinoCpf: string;
  logo: string;
  cdEmpresa: string;
  marca: string;
}

// Sem data/hora: o papel e assinado antes da transferencia acontecer.
export function montarTermoTransferencia(dados: TermoTransferenciaImpresso): string {
  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(dados.logo, dados.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Termo de Transferência</p>
        <p class="subtitle">Transferência de saldo de adiantamento</p>
        <p class="receipt-number">Adiantamento Nº ${dados.nrAdiantamento}</p>
      </div>
    </div>
    <table class="data">
      <tr><td class="label">Titular (quem pagou)</td><td class="value">${dados.origemNome || '—'}</td></tr>
      <tr><td class="label">CPF do titular</td><td class="value">${dados.origemCpf || '—'}</td></tr>
      <tr><td class="label">Saldo a liberar para</td><td class="value">${dados.destinoNome || '—'}</td></tr>
      <tr><td class="label">CPF do destinatário</td><td class="value">${dados.destinoCpf || '—'}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Saldo a transferir</div>
      <div class="amount">${formatBRL(dados.valor)}</div>
    </div>
    <p class="consent">
      Eu, ${dados.origemNome || '—'}, CPF ${dados.origemCpf || '—'}, titular do adiantamento
      Nº ${dados.nrAdiantamento}, autorizo que o saldo de ${formatBRL(dados.valor)} passe a ser
      utilizado por ${dados.destinoNome || '—'}, CPF ${dados.destinoCpf || '—'}.
      O pagamento continua registrado em meu nome; muda apenas quem pode utilizar o saldo.
    </p>
    <div class="signatures">
      <div class="signature"><div class="line"></div>Assinatura do titular</div>
      <div class="signature"><div class="line"></div>Assinatura do destinatário</div>
    </div>
    <div class="footer">${brandNameOrDefault(dados.marca)} — TERMO DE TRANSFERÊNCIA</div>
  `;
}
